import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page2() {
  useEffect(() => {
    document.title = "Маяк — Страница 2"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page1" />
        <ForwardLink href="/page3" />
      </div>

      <p style={{ textAlign: "right" }}>2.</p>
      <p>
        ДВОЕ МУЖЧИН В УНИФОРМЕ появляются и исчезают из поля зрения, неся<br/>
        припасы.
      </p>
      <p>Один отстает, неся на себе тяжелую ношу.</p>
      <p>
        Они проходят мимо небольшого полуразрушенного ЛОДОЧНОГО САРАЯ без двери.<br/>
        Плохо починенная ДОРИ -- СПАСАТЕЛЬНАЯ ЛОДКА -- привязана внутри<br/>
        и стоит на искривленных полозьях, уходящих в плещущиеся волны.
      </p>
      <br/>
      <p>
        СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. РЯДОМ С ЖИЛЫМИ ПОМЕЩЕНИЯМИ – ЗАКАТ<br/>
        ДВОЕ ДРУГИХ МУЖЧИН (лет 60, та же униформа) выходят из одноэтажной<br/>
        ОБШИТОЙ ДОСКАМИ ХИЖИНЫ, примыкающей к МАЯКУ удивительно<br/>
        ДЛИННЫМ ПЕРЕХОДОМ. Это уходящие ХРАНИТЕЛИ МАЯКА --<br/>
        «ВИККИ», как они себя называют. Они тащат мешки из наволочек<br/>
        на своих плечах и ящики с ручками из веревок<br/>
        по бокам, опустив головы. Их бородатые лица<br/>
        скалистые и свинцовые. От них пахнет табаком, суслом и солью.<br/>
        Они идут с облегчением: МУЖЧИНЫ С ТЕНДЕРА,<br/>
        несущие свои припасы.
      </p>
      <p>Четверо почти переглянулись. Но они не волнуются.</p>
      <p>ФОГОРН ревет.</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. РЯДОМ С ЖИЛЫМИ ПОМЕЩЕНИЯМИ – ПОЗЖЕ</p>
      <p>
        Новые викки стоят совершенно неподвижно, рядом друг с другом,<br/>
        их взгляды устремились в одну и ту же отдаленную точку.
      </p>
      <p>
        Один из мужчин МОЛОД (около 30 лет). Высокий, спортивный, но изморенный голодом.<br/>
        Его глубоко посаженные глаза затравлены, левый глаз заживает<br/>
        после фингала недельной давности. Его кривое выражение лица сурово.<br/>
        В нем чувствуется жуткая тревога. Он как собака, которую<br/>
        слишком часто избивали и держали в клетке. Маленькие усы выдают
        его тщеславие.
      </p>
      <p>
        Другой – СТАРИК (изможденный 60-летний? бодрый 70-летний?). Он обветренный,<br/>
        дикий, бородатый и сгорбленный, с руками, похожими на тиски. Отсутствие<br/>
        видимых губ предполагает отсутствие некоторых зубов. Он дрожит<br/>
        немного, но он худой и крепкий как свинцовая труба. Его высокие<br/>
        скулы улыбаются, даже когда он гримасничает. Его дикие глаза сияют<br/>
        как драгоценности. Он старый пан. Сатир.
      </p>
      <p>
        Они оба выглядят как те мужчины, которых вы можете встретить<br/>
        бормочущими про себя в углу пустого бара,<br/>
        с отстраненным взглядом в глазах.
      </p>
      <p>
        Они смотрят, как ТЕНДЕР покидает остров, очень-и-очень<br/>
        медленно исчезая, снова поглощенный туманом.
      </p>
      <p style={{ textAlign: "right" }}>2.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page1" />
        <ForwardLink href="/page3" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1708106930/the-lighthouse-script/wrttqy13tsodgosvojqj.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page2;
